import { createImage } from "@gluestack-ui/image";
import { Image as RNImage } from "react-native";
import { styled } from "@gluestack-style/react";
import React, { forwardRef, memo } from "react";
import { IImageProps } from "@gluestack-ui/image/lib/typescript/types";
const StyledRoot = styled(
	RNImage,
	{
		maxWidth: "$full",
		variants: {
			size: {
				"2xs": {
					w: "$6",
					h: "$6",
				},
				xs: {
					w: "$10",
					h: "$10",
				},
				sm: {
					w: "$16",
					h: "$16",
				},
				md: {
					w: "$20",
					h: "$20",
				},
				lg: {
					w: "$24",
					h: "$24",
				},
				xl: {
					w: "$32",
					h: "$32",
				},
				"2xl": {
					w: "$64",
					h: "$64",
				},
				full: {
					w: "$full",
					h: "$full",
				},
			},
		},
		defaultProps: {
			size: "md",
		},
	},
	{},
);

const RawImage = createImage({ Root: StyledRoot });

export const Image = memo(
  forwardRef<any, IImageProps>((props, ref) => {
    return <RawImage {...props} ref={ref} />;
  })
);